import { CircleDashed } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@atrvd/saas-ui'

interface SageNotConnectedProps {
  /** Organization name, shown so the message names WHICH tenant is unconnected. */
  organizationName: string | null
}

/**
 * What an organization without the Sage Intacct integration sees where the
 * integration would have been (DCP-368).
 *
 * Rendered in place of a whole screen or a whole tab rather than as disabled
 * buttons: with no connection there is nothing on those surfaces worth showing
 * — every table below them lists Sage catalogs — and a greyed-out control
 * invites the user to keep trying something that cannot work.
 *
 * Shared by `/settings/sage` and the Intacct Balances tab because they are two
 * entrances to the same syncs. The wording is the deliverable here: the user
 * cannot fix this themselves, so the message says who can.
 */
export function SageNotConnected({ organizationName }: SageNotConnectedProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CircleDashed className="h-5 w-5 text-muted-foreground" />
          Not connected
        </CardTitle>
        <CardDescription>
          Sage Intacct is not set up{organizationName ? ` for ${organizationName}` : ''}.
        </CardDescription>
      </CardHeader>
      <CardContent className="text-sm text-muted-foreground">
        Contact your administrator to have this organization connected. Until then no Sage data is
        imported and no sync is available here.
      </CardContent>
    </Card>
  )
}
